export const CATEGORIES = [
  'Food & Dining',
  'Transportation',
  'Shopping',
  'Groceries',
  'Entertainment',
  'Utilities',
  'Healthcare',
  'Education',
  'Travel',
  'Finance',
  'Investment',
  'Self Transfer',
  'Other',
];
